import { sgiLogger } from "../sgiCommon/sgiLogger";
// import ObjectManager from './ObjectManager'
/*     对象工厂
 --------------------------------------------------------------------------------
 作者：王哲                           创建日期：2018/03/12
 --------------------------------------------------------------------------------
 提供方法列表：
 ★对象保存
 ★对象读取
 ★根据参数guid创建对象  
 ★对象删除
 --------------------------------------------------------------------------------
 修改：                               修改日期：
 修改内容: 

 --------------------------------------------------------------------------------
 
 *******************************************************************************/
class ObjFactory {

	// objFct = null;
	// _pObjFct = null;

	constructor(uid, transferData, _pObjFct) {
		this.objFct = {};
		this._pObjFct = null;

		if (uid) this.objFct['@currentObjFctUID'] = uid;
		if (transferData) {
			for (const key in transferData) {
				this.objFct[key] = transferData[key];
			}
		}
		if (_pObjFct) this._pObjFct = _pObjFct;
		// ObjectManager.add(uid, this.objFct);
	}
	setUID(uid) {
		if (uid) {
			this.objFct['@currentObjFctUID'] = uid;
		}
	}
	getUID() {
		let uid = this.objFct['@currentObjFctUID'];
		return uid;
	}
	setParent(_pObjFct) {
		if (_pObjFct) this._pObjFct = _pObjFct;
	}
	getParent() {
		return this._pObjFct;
	}
	getAP() {
		let uid = this.getUID();
		if (!uid) return null;
		let ap = uid.split("_")[0];
		return ap;
	}
	/**
	 * 将对象保存到对象工厂中
	 * @param {type} pObj
	 * @param {type} pInstanceName
	 * @returns {undefined}
	 */
	set(pInstanceName, pObj) {
		if (!pInstanceName) return;
		if (RegExp(/[.|\[|\]]+/).test(pInstanceName)) {
			// 带层级写入，避免为空报错
			try {
				eval(`(this.objFct.${pInstanceName} = pObj)`);
			} catch (error) {
				sgiLogger.eventErr(error);
			}
		} else {
			this.objFct[pInstanceName] = pObj;
		}
	}
	/**
	 * 取得对象工厂中缓存的对象
	 * @param {type} pInstanceName
	 * @returns {unresolved}
	 */
	get(pInstanceName) {
		if (!pInstanceName) return null;
		if (RegExp(/[.|\[|\]]+/).test(pInstanceName)) {
			// 带层级读取，避免为空报错
			let obj;
			try {
				obj = eval(`(this.objFct.${pInstanceName})`);
			} catch (error) {
				sgiLogger.eventErr(error);
			}
			return obj;
		} else {
			return this.objFct[pInstanceName];
		}
	}
	/**
	 * 删除对象工厂中的对象
	 * @param {type} pInstanceName
	 * @returns {undefined}
	 */
	remove(pInstanceName) {
		delete this.objFct[pInstanceName];
	}
	clear(sonItems) {
		let clearObj;
		if (sonItems) {
			clearObj = sonItems;
		} else {
			clearObj = this.objFct;
		}
		for (const key in clearObj) {
			// const element = clearObj[key];
			delete clearObj[key]
		}
		clearObj = undefined;
	}

};

export { ObjFactory };
export default ObjFactory;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiFactory/ObjFactory.js